import "./pd-history/pd-history-item.js";
import { PdHistoryList } from "./pd-history/PdHistoryList.js";
import { HistoryFooterStyles } from "./pd-history/history-footer-styles.js";
//#region src/pd-history/pd-history-list.ts
var tag = "pd-history-list";
if (!customElements.get(tag)) customElements.define(tag, PdHistoryList);
//#endregion
export { HistoryFooterStyles, PdHistoryList };
